import { Component, OnInit } from '@angular/core';
import { Form } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudService } from 'environments/crud.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [ CrudService ]
})
export class LoginComponent implements OnInit {
  user = ""
  password = ""
  constructor(
    private crud: CrudService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('usuario')
  }

  onSubmit(form: Form) {
    this.crud.login({user:this.user, password:this.password, tipo:'Admin'}).subscribe(
      response => {
        sessionStorage.setItem('token', response.token)
        sessionStorage.setItem('usuario', JSON.stringify(response.usuario))
        this.router.navigate(['/'])
      },
      error => {
        swal.fire('¡Oops!', error.error.error)
        
      }
    )
  }

}
